<section class="page">
  <header class="page-header">
    <h2>Cartouches commandées</h2>
    <p class="subtitle">Liste des cartouches avec commande de séquençage active.</p>
  </header>

  <section class="panel">
    <button type="button" (click)="refresh()" [disabled]="loading">
      {{ loading ? 'Chargement...' : 'Actualiser la liste' }}
    </button>

    @if (success) {
      <p class="success">{{ success }}</p>
    }

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des cartouches commandées...</p>
    } @else if (items.length === 0) {
      <p class="meta">Aucune cartouche commandée.</p>
    } @else {
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Nom</th>
              <th>Action commande</th>
              <th>Date de séquençage</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.id) {
              <tr>
                <td>{{ item.nom }}</td>
                <td>
                  <button
                    type="button"
                    class="btn-danger"
                    [disabled]="savingByNom[item.nom]"
                    (click)="markAsNotCommanded(item)"
                  >
                    {{ savingByNom[item.nom] ? 'En cours...' : 'Retirer la cartouche de la commande' }}
                  </button>
                </td>
                <td>
                  <div class="inline-form">
                    <input
                      type="date"
                      [ngModel]="dateByNom[item.nom]"
                      (ngModelChange)="dateByNom[item.nom] = $event"
                    />
                    <button
                      type="button"
                      [disabled]="savingByNom[item.nom]"
                      (click)="saveDate(item)"
                    >
                      Enregistrer
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</section>
